import { Box } from "@mui/material";

import { PresetType } from "../../types";

export const PresetIcon = ({ preset }: { preset: PresetType }) => {
  const isWide = preset.aspectRatio >= 1;

  return (
    <Box
      sx={[
        {
          height: 24,
          width: 24,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        (theme) => ({
          backgroundColor: theme.palette.secondary[6],
          boxShadow: `inset 0 0 0 0.5px ${theme.palette.secondary["4/50"]}`,
        }),
      ]}
    >
      <Box
        sx={{
          minWidth: 24,
          minHeight: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={(theme) => ({
            aspectRatio: Math.min(Math.max(preset.aspectRatio, 0.5), 2),
            border: "1px solid",
            borderColor: theme.palette.secondary[3],
            borderRadius: "2px",
            flex: 1,
            ...(isWide ? { maxWidth: "14px" } : { maxWidth: "9px" }),
          })}
        />
      </Box>
    </Box>
  );
};
